import { UploadRowsState } from '../../store/state';
import { UploadAction, UploadActions } from '../actions';

const initialState: UploadRowsState = {
  data: null,
  loading: false,
  error: null,
};

const uploadRowsReducer = (state: UploadRowsState = initialState, action: UploadAction): UploadRowsState => {
  switch (action.type) {
    case UploadActions.ClearRows:
      return initialState;
    case UploadActions.LoadRowsRequest:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case UploadActions.LoadRowsSuccess:
      return {
        ...state,
        loading: false,
        error: null,
        data: action.rows,
      };
    case UploadActions.UpdateRowSuccess:
      return {
        ...state,
        loading: false,
        error: null,
        data: [
          ...state.data.filter(task => task.id !== action.task.id),
          action.task,
        ],
      };
    default:
      return state;
  }
};

export default uploadRowsReducer;